import React, { Component }  from 'react'
import { Button, Icon } from 'semantic-ui-react'

import {
    ExcelExport,
    ExcelExportColumn
} from '@progress/kendo-react-excel-export'

import moment from 'moment'

class TeachersExport extends Component {
    _exporter;
    export = () => {
        this.save(this._exporter);
    }
    save = (component) => {
      const options = component.workbookOptions();
      const rows = options.sheets[0].rows;

      console.log(rows)
      rows.forEach((row) => {
        if (row.type === 'data') {
          row.cells[6].value = moment(row.cells[6].value).format('MMM DD, YYYY')
        }
      });

      component.save(options);
    };

    render() {
        return (
            <div>
                <Button icon labelPosition='right' onClick={this.export}>
                  <Icon name='download' />
                  Export Teachers
                </Button>

                <ExcelExport
                    data={this.props.data}
                    fileName="Teachers.xlsx"
                    ref={(exporter) => { this._exporter = exporter; }}
                >
                  <ExcelExportColumn field="firstName" title="First Name" locked={true} width={200} />
                  <ExcelExportColumn field="lastName" title="Last Name" locked={true} width={200} />
                  <ExcelExportColumn field="middleName" title="Middle Name" width={200} />
                  <ExcelExportColumn field="extensionName" title="Extension Name" width={200} />
                  <ExcelExportColumn field="address" title="Address" width={500} />
                  <ExcelExportColumn field="gender" title="Gender" width={200} />
                  <ExcelExportColumn field="birthDate" title="Birthdate" width={200} />
                  <ExcelExportColumn field="email" title="Email" width={200} />
                  <ExcelExportColumn field="contactNumber" title="Contact Number" width={200} />
                  <ExcelExportColumn field="employmentType" title="Employment Type" width={200} />
                  <ExcelExportColumn field="yearsOfTeaching" title="Years of Teaching" width={100} />
                  <ExcelExportColumn field="yearsOfTeachingSALIS" title="Years of Teaching SALIS" width={100} />
                  <ExcelExportColumn field="degreeEarned" title="Degree" width={300} />
                </ExcelExport>
            </div>
        );
    }
}

export default TeachersExport;
